(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Heightenergummies"] && !Shopify.designMode) return;
  try {
    
/* Heightener landing page: bundle picker + one-time / subscribe toggle */
(function () {
  function initOffer(root) {
    if (!root || root.dataset.hhReady) return;
    root.dataset.hhReady = 'true';
    var sid = root.dataset.section;
    var idInput = root.querySelector('[data-hh-id]');
    var qtyInput = root.querySelector('[data-hh-qty]');
    var planInput = root.querySelector('[data-hh-plan]');
    var returnInput = root.querySelector('[data-hh-return]');
    var selName = root.querySelector('[data-hh-sel-name]');
    var selPrice = root.querySelector('[data-hh-sel-price]');
    var selPlan = root.querySelector('[data-hh-sel-plan]');
    var bundles = root.querySelectorAll('input[name="hh-bundle-' + sid + '"]');
    var plans = root.querySelectorAll('input[name="hh-plan-' + sid + '"]');

    function checked(list) {
      for (var i = 0; i < list.length; i++) { if (list[i].checked) return list[i]; }
      return list[0];
    }

    function apply() {
      var b = checked(bundles);
      var p = checked(plans);
      var sub = !!(p && p.value === 'sub');
      root.querySelectorAll('[data-hh-save]').forEach(function (el) {
        var savings = sub ? el.dataset.sub : el.dataset.once;
        el.textContent = savings || '';
        el.classList.toggle('hh-bundle__save--empty', !savings);
        if (savings) el.removeAttribute('aria-hidden');
        else el.setAttribute('aria-hidden', 'true');
      });
      root.querySelectorAll('.hh-bundle__note, .hh-bundle__badge').forEach(function (el) {
        el.style.display = sub ? 'none' : '';
      });
      root.querySelectorAll('[data-hh-price]').forEach(function (el) {
        el.textContent = sub ? el.dataset.sub : el.dataset.once;
      });
      root.querySelectorAll('[data-hh-per]').forEach(function (el) {
        el.textContent = sub ? el.dataset.sub : el.dataset.once;
      });
      if (!b) return;
      if (!b.checked) b.checked = true;
      var d = b.dataset;
      if (idInput && d.variant) idInput.value = d.variant;
      if (qtyInput) qtyInput.value = d.qty || '1';
      if (planInput) {
        planInput.value = sub ? (root.dataset.plan || '') : '';
        planInput.disabled = !(sub && root.dataset.plan);
      }
      if (returnInput) returnInput.value = sub ? '/checkout' : (d.return || '/checkout');
      if (selName) selName.textContent = d.name || '';
      if (selPrice) selPrice.textContent = sub ? (d.priceSub || '') : (d.priceOnce || '');
      if (selPlan) selPlan.textContent = sub ? (root.dataset.subLabel || '') : (root.dataset.onceLabel || '');
    }

    // Start from the default bundle every time. Phones restore old radio
    // choices on reload or Back, so the "selected by default" tier is enforced here.
    function reset() {
      var found = false;
      bundles.forEach(function (r) { r.checked = r.defaultChecked; if (r.defaultChecked) found = true; });
      if (!found && bundles.length) {
        var fs = root.querySelector('[data-hh-default]');
        var di = fs && fs.dataset.hhDefault ? parseInt(fs.dataset.hhDefault, 10) - 1 : 1;
        (bundles[di] || bundles[Math.min(1, bundles.length - 1)]).checked = true;
      }
      plans.forEach(function (r) { r.checked = r.defaultChecked; });
      apply();
    }

    bundles.forEach(function (r) { r.addEventListener('change', apply); });
    plans.forEach(function (r) { r.addEventListener('change', apply); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
    reset();
  }

  function initGallery(root) {
    if (!root || root.dataset.hhReady) return;
    root.dataset.hhReady = 'true';
    var track = root.querySelector('[data-hh-track]');
    var dots = root.querySelectorAll('[data-hh-dot]');
    if (!track || !dots.length) return;
    function setActive(i) {
      dots.forEach(function (d, n) { if (n === i) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); } });
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.dataset.hhDot, 10) || 0;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        setActive(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
        ticking = false;
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) + (e.key === 'ArrowRight' ? 1 : -1);
      i = Math.max(0, Math.min(dots.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hh-offer]').forEach(initOffer);
    (scope || document).querySelectorAll('[data-hh-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
